/**
 * Clause library schemas (OPS 3.3) — Admin-managed reusable proposal clauses.
 * The composer pulls COPIES into a proposal; edits here never reach existing
 * proposals and edits inside a proposal never write back here.
 */

import { z } from 'zod';
import { idSchema, iso8601Schema } from './common';

export const clauseLibraryItemOutputSchema = z.object({
  id: idSchema,
  title: z.string().max(200),
  body: z.string(),
  active: z.boolean(),
  ordering: z.number().int(),
  createdAt: iso8601Schema,
  updatedAt: iso8601Schema,
});
export type ClauseLibraryItemOutput = z.infer<typeof clauseLibraryItemOutputSchema>;

export const createClauseLibraryItemInputSchema = z.object({
  title: z.string().min(1).max(200),
  body: z.string().min(1).max(10000),
  ordering: z.number().int().min(0).optional(),
});
export type CreateClauseLibraryItemInput = z.infer<typeof createClauseLibraryItemInputSchema>;

export const updateClauseLibraryItemInputSchema = createClauseLibraryItemInputSchema.partial().extend({
  active: z.boolean().optional(),
});
export type UpdateClauseLibraryItemInput = z.infer<typeof updateClauseLibraryItemInputSchema>;
